<template>
  <ul class="pagination">
    <li @click.prevent="pageChanged(1)">
      <a href="#" aria-label="Previous">
        <span aria-hidden="true">&laquo;</span>
      </a>
    </li>
    <li v-for="n in paginationRange"
      :key="n"
      :class="activePage(n)"
      @click.prevent="pageChanged(n)">
      <a href="#">{{ n }}</a>
    </li>
    <li @click.prevent="pageChanged(lastPage)">
      <a href="#" aria-label="Next">
        <span aria-hidden="true">&raquo;</span>
      </a>
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'pagination',
    props: {
      currentPage: {
        type: Number,
        required: true
      },
      totalPageNum: Number,
      visiblePages: {
        type: Number,
        default: 5
      }
    },
    computed: {
      parsePages () {
        return parseInt(this.visiblePages)
      },
      lastPage () {
        return this.totalPageNum
      },
      paginationRange () {
        let start = this.currentPage - this.visiblePages / 2 <= 0
          ? 1
          : this.currentPage + this.visiblePages / 2 > this.lastPage
            ? this.lowerBound(this.lastPage - this.visiblePages + 1, 1)
            : Math.ceil(this.currentPage - this.visiblePages / 2)
        let range = []
        for (let i = 0; i < this.visiblePages && i < this.lastPage; i++) {
          range.push(start + i)
        }
        return range
      }
    },
    methods: {
      pageChanged (pNum) {
        if (this.currentPage === pNum) return
        this.$emit('pageChange', pNum)
      },
      activePage (pageNum) {
        return this.currentPage === pageNum ? 'active' : ''
      },
      lowerBound (num, limit) {
        return num >= limit ? num : limit
      }
    }
  }
</script>

<style scoped>
  ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  li {
    display: flex;
    margin: .5em;
    width: 25px;
    height: 25px;
    text-align: center;
    border: 1px solid #cee3f0;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
  }
  li:first-child, li:last-child { 
    display: inline-block;
    line-height: 23px;
  }
  li:hover {
    background-color: rgba(000, 000, 000, .1);
    cursor: pointer;
  }
  .active {
    background-color: #efefef
  }
</style>


// WEBPACK FOOTER //
// Pagination.vue?d1abbe52